import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
export const LegalAcceptanceFields = ({ idPrefix, secondaryKind, termsAccepted, secondaryAccepted, submitted, termsError, secondaryError, onTermsChange, onSecondaryChange }) => {
    const { t } = useTranslation();
    const secondaryId = `${idPrefix}-${secondaryKind === 'service' ? 'service-start' : 'digital-start'}`;
    return (_jsxs(_Fragment, { children: [_jsxs(Consent, { "$error": submitted && termsError, children: [_jsx("input", { id: `${idPrefix}-terms`, type: "checkbox", checked: termsAccepted, onChange: (event) => onTermsChange(event.target.checked), "aria-invalid": submitted && termsError, "aria-describedby": submitted && termsError ? `${idPrefix}-terms-error` : undefined }), _jsx("span", { children: _jsx(Trans, { i18nKey: "checkout.termsConsent", components: {
                                terms: _jsx(Link, { to: "/terms" }),
                                refunds: _jsx(Link, { to: "/refund-policy" })
                            } }) })] }), submitted && termsError && (_jsx(AcceptanceError, { id: `${idPrefix}-terms-error`, children: t('checkout.required') })), _jsxs(Consent, { "$error": submitted && secondaryError, children: [_jsx("input", { id: secondaryId, type: "checkbox", checked: secondaryAccepted, onChange: (event) => onSecondaryChange(event.target.checked), "aria-invalid": submitted && secondaryError, "aria-describedby": submitted && secondaryError ? `${secondaryId}-error` : undefined }), _jsx("span", { children: t(secondaryKind === 'service' ? 'checkout.immediateService' : 'checkout.immediateDigital') })] }), submitted && secondaryError && (_jsx(AcceptanceError, { id: `${secondaryId}-error`, children: t('checkout.required') }))] }));
};
const Consent = styled.label `
  display: grid;
  grid-template-columns: 22px 1fr;
  gap: 0.8rem;
  align-items: start;
  margin-top: 1rem;
  border: 1px solid ${({ theme, $error }) => ($error ? theme.colors.danger : theme.colors.line)};
  padding: 1rem;
  cursor: pointer;
  line-height: 1.65;
  input {
    width: 18px;
    height: 18px;
    margin-top: 0.2rem;
    accent-color: ${({ theme }) => theme.colors.blue600};
  }
  a {
    color: ${({ theme }) => theme.colors.navy900};
    font-weight: 700;
    text-decoration: underline;
  }
`;
const AcceptanceError = styled.p `
  margin: 0.65rem 0 0;
  color: ${({ theme }) => theme.colors.danger};
  font-size: 0.875rem;
  line-height: 1.55;
`;
